import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";

@Component({
  selector: "app-preview-block",
  templateUrl: "./preview-block.component.html",
  styleUrls: ["./preview-block.component.scss"]
})
export class PreviewBlockComponent {
  @Input()
  blockText;

  @Output()
  action: EventEmitter<void> = new EventEmitter();

  /* blockText = {
    heading: 'Play Marvel Champions LCG',
    content: [
      'The Vibranium Society is an unofficial place where you can play Marvel Champions LCG for free.',
      'Play this tabletop sandbox like in real life. You can drag and drop card, add and update tokens, change counters, add card attachments and more..'
    ],
    action: 'Play'
  } */

  doAction() {
    this.action.emit();
  }

  onImageLoad(event) {
    console.info("onImageLoad", event);
  }
}
